// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase } from "@msnews/telemetry-contracts";

import { getPageContentType } from "../Social.telemetry";

export interface OnboardingPageTelemetryObjects {
    main: TelemetryObjectBase;
    step1Continue: TelemetryObjectBase;
    step1EditProfile: TelemetryObjectBase;
    step2ThanksPage: TelemetryObjectBase;
    step2LetsGo: TelemetryObjectBase;
}

export interface OnboardingThirdPartyPageTelemetryObjects {
    main: TelemetryObjectBase;
    onboardingThirdPartyPageSignIn: TelemetryObjectBase;
    onboardingThirdPartyPageCreateAccount: TelemetryObjectBase;
}

export const onboardingPageTelemetryContracts = {
    /** Comments-Scenario 4d */
    onboardingPage: {
        name: "CommunityWelcomeStep1",
        content: {
            type: getPageContentType()
        }
    },
    /** Comments-Scenario 4ciia */
    onboardingThirdPartyPage: {
        name: "CommunityLinkAccount",
        content: {
            type: getPageContentType(),
            headline: "ContinueWithMicrosoft"
        }
    },
    /** Scenario 4ciia (scenario index has duplicate) */
    onboardingThirdPartyPageSignIn: {
        name: "SignInWithThisAccount",
        behavior: TelemetryBehaviorType.SignIn,
        content: {
            type: getPageContentType(),
            headline: "SignInWithThisAccount"
        }
    },
    /** Scenario 4ciib*/
    onboardingThirdPartyPageCreateAccount: {
        name: "CreateNewMSA",
        behavior: TelemetryBehaviorType.Open,
        content: {
            type: getPageContentType(),
            headline: "CreateNewMSA"
        }
    },
    /** Comments-Scenario 4dii */
    step1Continue: {
        behavior: TelemetryBehaviorType.Close,
        name: "Continue",
        content: {
            type: getPageContentType(),
            headline: "Continue"
        }
    },
    /** Comments-Scenario 4di */
    step1EditProfile: {
        behavior: TelemetryBehaviorType.Navigate,
        name: "Edit Profile",
        content: {
            type: getPageContentType(),
            headline: "EditProfile"
        }
    },
    /** Comments-Scenario 4d2 */
    step2ThanksPage: {
        name: "CommunityWelcomeStep2",
        content: {type: TelemetryContentType.Article}
    },
    /** Comments-Scenario 4d2a */
    step2LetsGo: {
        behavior: TelemetryBehaviorType.Navigate,
        name: "LetsGo",
        content: {
            type: TelemetryContentType.Article,
            headline: "LetsGo"
        }
    }
};